/**
 * Meeting is requested, but there is not enough information
 * yet to schedule it
 */
export const ActivePending = 'active-pending';

/**
 * Meeting is declined by the majority of the attendees and
 * cannot be scheduled until we receive new information
 */
export const ActiveDeclined = 'active-declined';

export const ActiveNoOverlap = 'active-no-overlap';
export const ActiveNoAvailability = 'active-no-availability';
export const ActiveStatuses = [ActivePending, ActiveDeclined, ActiveNoOverlap, ActiveNoAvailability];

/**
 * Statuses that can cause meeting to be canceled, if it was previously scheduled
 */
export type CancelMeetingTypeStatuses =
    | typeof ActivePending
    | typeof ActiveDeclined
    | typeof ActiveNoAvailability
    | typeof ActiveNoOverlap;

export const CancelledViaZoom = 'cancelled-via-zoom';
export const CancelledByZoom = 'cancelled-by-zoom';

/**
 * This task was rescheduled via Zoom (chat). This task is now closed and new one is created.
 */
export const RescheduledViaZoom = 'rescheduled-via-zoom';
export const CancelledViaCalendar = 'cancelled-via-calendar';
export const CancelledPending = 'cancelled-pending';

export const CancelledStatuses = [CancelledViaZoom, RescheduledViaZoom, CancelledViaCalendar, CancelledPending];

export const Rescheduled = 'rescheduled';
export const Scheduled = 'scheduled';
export const ScheduledStatuses = [Scheduled, Rescheduled];
export const ZoomFailToSchedule = 'zoom-failed-to-schedule';
export const Expired = 'expired';

export const Completed = [...CancelledStatuses, Expired, ZoomFailToSchedule];
export const ReschedulableStatuses = [...ActiveStatuses, Scheduled, Rescheduled];
export type ReschedulableTaskStatuses = typeof ReschedulableStatuses[number];

export const MeetingStatuses = [...ActiveStatuses, Scheduled, Rescheduled, ...Completed];

export type MeetingTaskStatus = typeof MeetingStatuses[number];
